export default __webpack_public_path__ + "91beaeb4d2861e830cd33a5ca2dbc460.webp";